export function contentHandler() {
    const $imageInContent = $(".text-section p > img");

    if ($imageInContent.length > 0) {
        $imageInContent.closest("p").addClass("p-with-image");
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/content-handler.js